import { css, cx } from 'emotion'
import {
  museo900,
} from 'inside-out/global-styles'

export const cardsStyle = css({
  marginBottom: '150px',
  positon: 'relative',
  zIndex: '1',
})

export const stepCardStyle = css({
  ...museo900,
  position: 'relative',
  borderRadius: '8px',
  boxShadow: '0 6px 12px 0 rgba(0,0,0,0.18)',
  padding: '36px 24px',
  margin: '0 24px',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 12px 0 rgba(0,0,0,0.4)',
  }
})



// WEBPACK FOOTER //
// ./src/components/medicare/stepSelect/styles.js